<script setup lang="ts">
/**
 * FW-97 — `/kurulum` rotasi `meta.standalone` tasir ve genel AppShell/
 * FwSurfaceCard kabugunu (baslik+kart) ALMAZ: kurulum sihirbazinin kendi
 * tam-viewport ust seridi + sol adim rayi var, genel kabukla cakisir (bkz.
 * OnboardingView.vue basligi — apps/auth'un App.vue'sundaki AYNI gerekce).
 * Diger tum rotalar (bugun yalniz home) AppShell'i degismeden kullanmaya
 * devam eder.
 */
import { computed } from 'vue'
import { AppShell, useRoute } from '@fusapp-work/shell'

const route = useRoute()
const isStandalone = computed(() => route.meta.standalone === true)
</script>

<template>
  <router-view v-if="isStandalone" />
  <AppShell
    v-else
    surface="app"
  >
    <router-view />
  </AppShell>
</template>
